<template>
    <div>
        <div class="action-header">
            <div class="d-flex-wrap">
                <div class="search-container">
                    <div class="search-input">
                        <v-text-field
                            v-model="search"
                            prepend-inner-icon="search"
                            :placeholder="this.$vuetify.lang.t('$vuetify.blacklist.searchText')"
                            solo
                            height="40px"
                            width="280px"
                            @keyup.enter="searchBlacklistPunchLog()">
                        </v-text-field>

                        <div class="ml-3">
                            <v-btn
                                height="40"
                                color="primary"
                                outlined
                                @click="searchBlacklistPunchLog()">
                                {{ $vuetify.lang.t('$vuetify.blacklist.search') }}
                            </v-btn>
                        </div>
                    </div>
                    <div class="filter-input">
                        <date-picker-range
                            class="mr-3"
                            v-model="dateRange" />
                        <div class="status-filter">
                            <v-select
                                @change="searchBlacklistPunchLog()"
                                v-model="deviceFilter"
                                :items="deviceList"
                                item-text="text"
                                item-value="value"
                                outlined dense
                                height="40"
                                background-color="#ffffff">
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <v-btn
                    class="ml-3 btn-text-color"
                    height="40"
                    @click="genPdfReport()"
                    color="#ff544a">
                    {{ $vuetify.lang.t('$vuetify.blacklist.exportPDF') }}
                </v-btn>
                <v-btn
                    class="ml-3 btn-text-color"
                    height="40"
                    @click="genExcelReport()"
                    color="#139888">
                    {{ $vuetify.lang.t('$vuetify.blacklist.exportExcel') }}
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalBlacklistPunchLog"
                :items="blacklistPunchLog"
                :loading="loading">
                <template v-slot:[`item.snap_f_path`]="{ item }">
                    <div class="pointer icon-profile" @click="showImage(item.snap_f_path)">
                        <i class="fas fa-portrait"></i>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <image-preview
            ref="imagePreview" />
    </div>
</template>

<script>
import ImagePreview from '@/components/ImagePreview'
import DatePickerRange from '@/components/DatePickerRange.vue'

export default {
    name: 'BlacklistActivity',

    components: {
        ImagePreview,
        DatePickerRange
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            blacklistPunchLog: [],
            totalBlacklistPunchLog: 0,
            loading: false,
            deviceList: [],
            dateRange: [this.$dateUtil.getCurrentDate(), this.$dateUtil.getCurrentDate()],
            deviceFilter: null
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.blacklist.blacklistName'), value: 'fullName', width: '35%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.date'), value: 'date', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.detectTime'), value: 'time', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.image'), value: 'snap_f_path', align: 'center', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.location'), value: 'device_name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.temperatureShort'), value: 'temperature', width: '15%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        async initBlacklistActivity () {
            await this.getDeviceForFilter()
            await this.getBlacklistPunchLogList()
        },

        async getDeviceForFilter () {
            const res = await this.axios.get('blacklist/punch-log/options')
            if (res && res.data && res.data.status === 'ok') {
                this.deviceList = res.data.data
            }
        },

        async getBlacklistPunchLogList () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `blacklist/punch-log-list?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.deviceFilter) {
                url += `&device=${this.deviceFilter}`
            }

            if (this.dateRange) {
                if (this.dateRange.length === 1) {
                    url += `&startDate=${this.dateRange[0]}`
                } else if (this.dateRange.length === 2) {
                    url += `&startDate=${this.dateRange[0]}&endDate=${this.dateRange[1]}`
                }
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.blacklistPunchLog = res.data.data
                this.totalBlacklistPunchLog = res.data.total
                this.loading = false
            } else {
                this.loading = false
            }
        },

        async searchBlacklistPunchLog () {
            this.options.page = 1
            await this.getBlacklistPunchLogList()
        },

        showImage (path) {
            this.$refs.imagePreview.toggleShow(path)
        },

        async genPdfReport () {
            const form = {
                search: this.search,
                dateRange: this.dateRange,
                location: this.deviceFilter
            }
            localStorage.formData = JSON.stringify(form)
            const routeData = this.$router.resolve({ name: 'ReportBlacklistActivityPDF' })
            window.open(routeData.href)
        },

        async genExcelReport () {
            await this.$store.dispatch('setLoading', true)
            const response = await this.axios.post(
                'blacklist/punch-log/export/excel',
                {
                    search: this.search, dateRange: this.dateRange, location: this.deviceFilter
                }, {
                    headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
                    responseType: 'arraybuffer'
                })

            if (response && response.data) {
                const dateString = this.$dateUtil.getCurrentDate()
                this.$utils.downloadExcelFile(response.data, `blacklist-activity-report-${dateString}.xlsx`)
            } else {
                await this.$store.dispatch('setErrorModalShow', true)
                await this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.blacklist.somethingWrong'))
            }
            await this.$store.dispatch('setLoading', false)
        }
    },

    watch: {
        options: {
            async handler () {
                await this.initBlacklistActivity()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.initBlacklistActivity()
            },
            deep: true
        },
        dateRange () {
            if (this.dateRange.length === 0 || this.dateRange.length === 2) {
                this.searchBlacklistPunchLog()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-container {
        ::v-deep .v-input__control > .v-input__slot {
            min-height: auto !important;
            display: flex !important;
            align-items: center !important;
            box-shadow: none !important;
            border: 1px solid #a8a8a8 !important;
            width: 340px;
        }

        ::v-deep .date-range-input .v-input__control > .v-input__slot {
            width: 210px;
        }
    }
    ::v-deep .status-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
    ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin: 0 !important;
    }
    .d-flex-wrap {
        display: flex;
        flex-wrap: wrap;
    }
    .status-filter {
        max-width: 200px;
    }
    .icon-profile {
        color: #d76436;
        font-size: 18px;
    }
    .btn-text-color {
        color: #ffffff;
    }

    @media only screen and (max-width: 1625px) {
        .search-container {
            flex-wrap: wrap;
            max-width: 620px;
        }

        .filter-input {
            margin-left: 0px !important;
        }
    }
</style>
